const hasLimit = value => value !== '' && value !== null && value !== undefined && Number.isFinite(Number(value))

const numericValue = value => {
  if (typeof value === 'string') value = value.trim().replace(',', '.')
  if (value === '' || value === null || value === undefined) return null
  const number = Number(value)
  return Number.isFinite(number) ? number : null
}

export function classifyResultValue (value, reference = {}) {
  const number = numericValue(value)
  const hasMin = hasLimit(reference.min)
  const hasMax = hasLimit(reference.max)
  if (number === null || (!hasMin && !hasMax)) return null

  if (hasMin && number < Number(reference.min)) return { key: 'low', label: 'Bas', tone: 'warning' }
  if (hasMax && number > Number(reference.max)) return { key: 'high', label: 'Élevé', tone: 'danger' }
  return { key: 'normal', label: 'Normal', tone: 'success' }
}

export function referenceLabel (field = {}) {
  const reference = field.reference || {}
  const unit = field.unit || ''
  if (reference.text) return reference.text
  if (hasLimit(reference.min) && hasLimit(reference.max)) return `${reference.min} – ${reference.max} ${unit}`.trim()
  if (hasLimit(reference.min)) return `≥ ${reference.min} ${unit}`.trim()
  if (hasLimit(reference.max)) return `≤ ${reference.max} ${unit}`.trim()
  return ''
}

export function flattenAnalysisResult (data) {
  if (!Array.isArray(data)) return []

  if (data.some(section => Array.isArray(section && section.fields))) {
    return data.flatMap(section => (section.fields || []).map(field => ({
      section: section.title || 'Résultats',
      field,
    })))
  }

  return data.slice(1).flatMap((row, rowIndex) => {
    const cells = Array.isArray(row && row.cells) ? row.cells : []
    const label = cells[0] && cells[0].value ? cells[0].value : `Résultat ${rowIndex + 1}`
    const visit = (cell, context) => {
      if (!cell) return []
      if (Array.isArray(cell.subcells) && cell.subcells.length) {
        return cell.subcells.flatMap((child, index) => visit(child, `${context} / ${index + 1}`))
      }
      return [{ section: 'Résultats', field: { ...cell, label: cell.label || context } }]
    }
    const headings = (data[0] && data[0].cells) || []
    return cells.slice(1).flatMap((cell, index) => {
      if (cell && cell.merged) return []
      const column = index + 1
      const heading = headings.find((item, start) => item && !item.merged && start <= column && start + (Number(item.colspan) || 1) > column)
      return visit(cell, `${label} — ${(heading || {}).value || column}`)
    })
  })
}
